import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { ApolloLink } from '@apollo/client';
var appReleaseLink = /*#__PURE__*/new ApolloLink(function (operation, forward) {
  operation.setContext(function (_ref) {
    var _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;
    return {
      headers: _objectSpread(_objectSpread({}, headers), {}, {
        // keep in mind that we should not add the NEXT_PUBLIC_COMMIT_SHA to turbo.json
        // becaues it changes in every build
        'creh-app-version': process.env.NEXT_PUBLIC_COMMIT_SHA
      })
    };
  });
  return forward(operation);
});
export default appReleaseLink;